module.exports = __webpack_public_path__ + "logo-icon.ea3403d7b82a6519bebfb7cbff9d6cf8.png";